import $ from "jquery/dist/jquery";
window.jQuery = window.$ = $;
import("bootstrap3/dist/js/bootstrap");

const NXCMS_BOOTSTRAP = {
  toast: (msg, timeout = 4000, level = "warning") => {
    if (level == "error") {
      level = "danger";
    }

    let t = $("#bstoast");
    if (t.length) {
      t.remove();
    }

    $(document.body).append(`
      <div id="bstoast" class="alert alert-${level} alert-dismissible fade in" role="alert">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <span class="toast-body"></span>
      </div>
    `);
    t = $("#bstoast");
    const tcontent = $("#bstoast .toast-body");
    tcontent.html(msg);

    setTimeout(() => {
      t.fadeOut("slow", () => {
        t.remove();
      });
    }, timeout);
  },

  showMessages: (messages, timeout = 4000) => {
    messages.forEach((msg) => {
      window.NXCMS.toast(msg.message, msg.timeout || timeout, msg.level || "warning");
    });
  },

  modalClose: (el) => {
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    $(el).modal("hide");
  },

  modal: (el, show = true) => {
    if (show) {
      $(el).modal();
    } else {
      NXCMS_BOOTSTRAP.modalClose(el);
    }
  },

  collapse: (el, show = true) => {
    if (show) {
      $(el).collapse("show");
    } else {
      $(el).collapse("hide");
    }
    return $(el);
  },
};

window.NXCMS = NXCMS_BOOTSTRAP;
